import { supabase } from '../../../../../lib/supabase';
import { LeaveWorkspaceProps } from './types';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../../../dialog';
import { useState } from 'react';
import { Button } from '../../../button/button';
import clsx from 'clsx';
import LoadingSpinner from '../../../loading-spinner';
import { leaveWorkspace } from '../../../../../lib/api';

export function LeaveWorkspace({
  authUser,
  fetchWorkspaceProfiles,
}: LeaveWorkspaceProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLeave = async () => {
    setError(null);
    setIsLoading(true);

    try {
      await leaveWorkspace({
        workspaceId: authUser?.currentWorkspace?.workspace_id || '',
      });

      supabase.auth.getSession().then(({ data: { session } }) => {
        if (session?.user) {
          fetchWorkspaceProfiles(session?.user);
        }
      });
    } catch (err) {
      console.error('Error leaving the workspace:', err);
      setError('Failed to leave the workspace. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" className="text-red-600 hover:text-red-700">
          Leave
        </Button>
      </DialogTrigger>

      <DialogContent>
        <DialogHeader>
          <DialogTitle>Leave workspace</DialogTitle>
          <DialogDescription>
            Are you sure you want to leave this workspace? This action cannot be
            undone. You will need an invitation to rejoin.
          </DialogDescription>
          {error && <p className="text-sm text-red-500">{error}</p>}
        </DialogHeader>

        <DialogFooter>
          <Button
            onClick={handleLeave}
            disabled={isLoading}
            variant="outline"
            className={clsx(
              'text-red-600 hover:text-red-700',
              isLoading && 'px-11',
            )}
          >
            {isLoading ? <LoadingSpinner strokeWidth={7} /> : 'Leave'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
